export default {
  objectName: "便民商城",
  platformId: 'shop',
  point: { lng: 113.292656, lat: 30.349297 },
  mapAttr: {
    mapType: "BMAP_NORMAL_MAP",
    zoom: 11
  },
  // 希耀线上
  apiRequestUrl: 'https://gateway.anluoyun.cn/mall',
  CopyRight: "Copyright @2020-2025 河南安洛云信息科技有限公司",
}
